import { useEffect } from 'react';
import { gql } from '@apollo/client';

import { useLazyGraphql } from 'utils/hooks/useLazyGraphql';
import { doesExist } from 'utils/tsHelpers';

import { parseXAIData } from '../utils/context';
import { BrandAffinityXAIData } from '../types';

export const fetchUserProfileXAI = gql`
query getUserProfileXAI($userKey: String, $email: String, $brandAffinityLabel: String, $uuid: String) {
  explainBrandAffinityForUserProfile(userKey: $userKey, email: $email, brandAffinityLabel: $brandAffinityLabel, uuid: $uuid) {
      userId
      label
      computedDate
      history {
        date
        label
      }
      topCampaigns {
        action
        campaignId
        channel
        date
      }
      userStats {
        compareFrom
        count
        event
        medianAbsolute
      }
    }
  }
`;

export const useXAIUserProfileQuery = (
  userUuidKey: string | undefined,
  userEmailKey: string | undefined,
  brandAffinityLabel: string | undefined,
) => {
  const { fetch, data, isLoading, error } =
    useLazyGraphql<BrandAffinityXAIData>(fetchUserProfileXAI);

  useEffect(() => {
    fetch({ uuid: userUuidKey, email: userEmailKey, brandAffinityLabel: brandAffinityLabel });
  }, [userUuidKey, userEmailKey, brandAffinityLabel]);

  if (!doesExist(userUuidKey) && !doesExist(userEmailKey)) {
    return {
      isLoading: false,
      data: parseXAIData(undefined),
      isError: true,
    };
  }

  return {
    isLoading,
    data: parseXAIData(data?.explainBrandAffinityForUserProfile),
    isError: !!error,
  };
};
